"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findCoverDesign = exports.getAllowedDesigns = exports.getLayersForDesign = exports.findMatchingOrDefaultDesign = exports.isDesignAllowedForPrintableIdx = exports.isDesignAllowedForPageCount = exports.getCardDesignOptions = exports.getCoverDesignOptions = exports.getBookInteriorDesignOptions = exports.getBookInteriorDesign = void 0;
exports.findLayersInTemplate = findLayersInTemplate;
/* eslint-disable @typescript-eslint/ban-ts-comment */
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const either_1 = require("../../types/either");
const Design_1 = require("../../models/Design");
const layers_1 = require("../layers");
const isDesignAllowedForPageCount_1 = __importDefault(require("./isDesignAllowedForPageCount"));
const constants_1 = require("./constants");
const isDesignAllowedForPages_1 = __importDefault(require("./isDesignAllowedForPages"));
const getTemplateSurface_1 = require("../printables/getTemplateSurface");
var getBookInteriorDesign_1 = require("./getBookInteriorDesign");
Object.defineProperty(exports, "getBookInteriorDesign", {
  enumerable: true,
  get: function () {
    return __importDefault(getBookInteriorDesign_1).default;
  }
});
var getBookInteriorDesignOptions_1 = require("./getBookInteriorDesignOptions");
Object.defineProperty(exports, "getBookInteriorDesignOptions", {
  enumerable: true,
  get: function () {
    return __importDefault(getBookInteriorDesignOptions_1).default;
  }
});
var getCoverDesignOptions_1 = require("./getCoverDesignOptions");
Object.defineProperty(exports, "getCoverDesignOptions", {
  enumerable: true,
  get: function () {
    return __importDefault(getCoverDesignOptions_1).default;
  }
});
var getCardDesignOptions_1 = require("./getCardDesignOptions");
Object.defineProperty(exports, "getCardDesignOptions", {
  enumerable: true,
  get: function () {
    return getCardDesignOptions_1.getCardDesignOptions;
  }
});
var isDesignAllowedForPageCount_2 = require("./isDesignAllowedForPageCount");
Object.defineProperty(exports, "isDesignAllowedForPageCount", {
  enumerable: true,
  get: function () {
    return __importDefault(isDesignAllowedForPageCount_2).default;
  }
});
var isDesignAllowedForPrintableIdx_1 = require("./isDesignAllowedForPrintableIdx");
Object.defineProperty(exports, "isDesignAllowedForPrintableIdx", {
  enumerable: true,
  get: function () {
    return __importDefault(isDesignAllowedForPrintableIdx_1).default;
  }
});
var findMatchingOrDefaultDesign_1 = require("./findMatchingOrDefaultDesign");
Object.defineProperty(exports, "findMatchingOrDefaultDesign", {
  enumerable: true,
  get: function () {
    return findMatchingOrDefaultDesign_1.findMatchingOrDefaultDesign;
  }
});
/**
 * Gets layers for provided design(s) off the template.
 *
 * If only one design is provided, it returns the layers for that design.
 * If two designs are provided, it returns a composite of the layers from both designs,
 * with the layers from the second design shifted to the right.
 *
 * @param printableGroupType - Optional type of the printable group. Some products don't use printable group types, but it should be provided if applicable.
 * @param template - The template to get layers from.
 * @param design1 - The primary design to get layers for.
 * @param design2 - Optional secondary design to create a composite design.
 *
 */
const getLayersForDesign = _ref => {
  let {
    printableGroupType,
    template,
    design1,
    design2
  } = _ref;
  try {
    const findLayersInTemplateResult = findLayersInTemplate(template, design1);
    if (findLayersInTemplateResult.isLeft()) {
      return (0, either_1.left)(findLayersInTemplateResult.value);
    }
    if (design2) {
      const findLayersInTemplateResult2 = findLayersInTemplate(template, design2);
      if (findLayersInTemplateResult2.isLeft()) {
        return (0, either_1.left)(findLayersInTemplateResult2.value);
      }
      const surface = (0, getTemplateSurface_1.getTemplateSurface)({
        template,
        printableGroupType
      });
      const shiftedLayers = (0, layers_1.shiftDesignLayersRight)(findLayersInTemplateResult2.value, surface);
      const compositeLayers = [...findLayersInTemplateResult.value, ...shiftedLayers];
      return (0, either_1.right)(compositeLayers);
    } else {
      return (0, either_1.right)(findLayersInTemplateResult.value);
    }
  } catch (err) {
    return (0, either_1.left)(err);
  }
};
exports.getLayersForDesign = getLayersForDesign;
function findLayersInTemplate(template, design) {
  const layers = design.layers.map(lid => {
    const layer = template.layers.find(l => l.id === lid);
    if (!layer) {
      return (0, either_1.left)(new Error(`Layer not found: ${lid}`));
    }
    return (0, either_1.right)(Object.assign({}, layer));
  });
  const {
    lefts,
    rights
  } = (0, either_1.splitArray)(layers);
  if (lefts.length > 0) {
    return (0, either_1.left)(new Error(lefts.map(e => e.message).join('\n')));
  }
  return (0, either_1.right)(rights);
}
const getAllowedDesigns = _ref2 => {
  let {
    allowedPages,
    interiorPageCount,
    designs,
    coverage
  } = _ref2;
  const designsAllowedByPageCountAndPages = designs.filter(design => {
    return (0, isDesignAllowedForPageCount_1.default)(design, interiorPageCount) && (0, isDesignAllowedForPages_1.default)(design, allowedPages);
  });
  if (!designsAllowedByPageCountAndPages.length) {
    return (0, either_1.left)(new Error(`No design found in allowedPageCount range for ${interiorPageCount} interior printables and allowedPages: "${allowedPages}"`));
  }
  const designsWithMatchingCoverage = designsAllowedByPageCountAndPages.filter(design => design.coverage === coverage);
  if (!designsWithMatchingCoverage.length) {
    return (0, either_1.left)(new Error(`No design found within allowedPageCount range for interiorPageCount: ${interiorPageCount}, allowedPages: "${allowedPages}" with matching coverage: "${coverage}"`));
  }
  return (0, either_1.right)(designsWithMatchingCoverage);
};
exports.getAllowedDesigns = getAllowedDesigns;
const findCoverDesign = (templateDesigns, interiorPrintableCount, designId) => {
  const coverDesigns = templateDesigns.filter(d => {
    const isFirstPageDesign = d.allowedPages === constants_1.FIRST;
    return isFirstPageDesign && (0, isDesignAllowedForPageCount_1.default)(d, interiorPrintableCount);
  });
  // If a designId was provided, look for a design with that ID. Otherwise look for the design marked as default
  let design = coverDesigns.find(design => designId ? design.id === designId : design.default);
  if (!design) {
    design = coverDesigns[0];
  }
  if (!(0, Design_1.isDesign)(design)) {
    return (0, either_1.left)(new Error('findCoverDesign: No design found in template'));
  }
  return (0, either_1.right)((0, lodash_clonedeep_1.default)(design));
};
exports.findCoverDesign = findCoverDesign;